// extracted by mini-css-extract-plugin
export default {"loading":"lazyImg_loading__Hp1hH","lazyImg":"lazyImg_lazyImg__T09WE"};